import { Controller } from "@hotwired/stimulus"
import { showConfirmDialog } from "../helpers/confirm_dialog"

// Tracks which pantry-item checkboxes are checked across the page and
// surfaces a floating action bar with bulk "Add to list" and "Delete"
// once at least one item is selected. Each bulk action is a regular form
// submit — this controller just funnels the selected ids into the form's
// hidden ids fields right before submit.
export default class extends Controller {
  static targets = ["checkbox", "bar", "addForm", "deleteForm"]

  connect() {
    this.update()
  }

  // The on-list toggle replaces a row's turbo frame (checkbox included,
  // reset to unchecked) — re-evaluate so the bulk bar's count stays
  // truthful instead of floating with stale ids.
  checkboxTargetConnected() {
    this.update()
  }

  checkboxTargetDisconnected() {
    this.update()
  }

  update() {
    const count = this.selectedIds.length
    if (this.hasBarTarget) this.barTarget.classList.toggle("hidden", count === 0)
  }

  clear() {
    this.checkboxTargets.forEach((cb) => { cb.checked = false })
    this.update()
  }

  submitAdd(event) {
    if (!this.hasAddFormTarget) return
    this.beforeSubmit(event, this.addFormTarget)
  }

  async submitDelete(event) {
    if (!this.hasDeleteFormTarget) return
    // requestSubmit() below re-fires this same submit handler so Turbo can
    // intercept it as a Turbo Stream request — this flag lets that second
    // pass through instead of re-opening the confirm dialog and looping.
    if (this.deleteConfirmed) {
      this.deleteConfirmed = false
      return
    }
    event.preventDefault()
    const count = this.selectedIds.length
    const confirmed = await showConfirmDialog(`Remove ${count} item${count === 1 ? "" : "s"} from your inventory?`)
    if (!confirmed) return
    this.beforeSubmit(event, this.deleteFormTarget)
    this.deleteConfirmed = true
    this.deleteFormTarget.requestSubmit()
  }

  beforeSubmit(event, form) {
    const ids = this.selectedIds
    if (ids.length === 0) {
      event.preventDefault()
      return
    }

    form.querySelectorAll("input[name='pantry_item_ids[]'][data-bulk]").forEach((el) => el.remove())
    ids.forEach((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "pantry_item_ids[]"
      input.value = id
      input.dataset.bulk = "true"
      form.appendChild(input)
    })
  }

  get selectedIds() {
    return this.checkboxTargets.filter((cb) => cb.checked).map((cb) => cb.value)
  }
}
